export default __webpack_public_path__ + "ch-live-casino.icon-c8aeeb1fa2ac59b598b22270a26dfcb4.png";